import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import CheckCircle from '@mui/icons-material/CheckCircle';
import type { SwaggerOutline } from '../../types/mappingDocument';
import { plural } from './mappingScope';

const metaSx = { fontSize: 13, color: 'text.secondary' } as const;

interface SpecSummaryProps {
  title: string;
  outline: SwaggerOutline;
}

/** Confirms the loaded spec and its size. */
const SpecSummary: React.FC<SpecSummaryProps> = ({ title, outline }) => {
  const { info } = outline;
  const specLabel = info.specVersion ? `${info.specVersion.startsWith('2') ? 'Swagger' : 'OpenAPI'} ${info.specVersion}` : null;
  return (
    <Box
      role="status"
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        columnGap: 2,
        rowGap: 0.5,
        px: 2,
        py: 1.5,
        borderRadius: 3,
        bgcolor: alpha(theme.palette.primary.main, 0.08),
      })}
    >
      <CheckCircle sx={{ fontSize: 20, color: 'primary.dark' }} />
      <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{title}</Typography>
      {info.version && <Typography sx={metaSx}>v{info.version}</Typography>}
      {specLabel && <Typography sx={metaSx}>{specLabel}</Typography>}
      <Typography sx={metaSx}>{plural(outline.operations.length, 'operation')}</Typography>
      <Typography sx={metaSx}>{plural(info.schemaCount, 'schema')}</Typography>
      <Typography sx={metaSx}>{plural(outline.tags.length, 'tag')}</Typography>
    </Box>
  );
};

export default memo(SpecSummary);
